import { TableCheckbox } from '../../../_core/table/table-checkbox.component';
import { FileTypeIcon } from '../../../_editor/upload/file-type-icon';
import { IDownloadRequestAssetsGridColumnItem } from './download-request-assets.types';

export const DownloadRequestAssetsGridColumnItem = ({
  ignoreIcon,
  index,
  item: { id, name },
  onSelect,
  selected,
  type
}: IDownloadRequestAssetsGridColumnItem) => {
  return (
    <div className="flex gap-2 items-start">
      <TableCheckbox useDiv checked={selected} onChange={() => onSelect?.({ id, fileName: name, index, type })} />
      {!ignoreIcon && (
        <div className="w-6">
          <FileTypeIcon color="#FF0042" fileName={name} />
        </div>
      )}
      <span className="text-xs leading-7">{name}</span>
    </div>
  );
};
